import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { TAccountProviderUser, TAccountProviderUserResponse, adaptAccountProviderUserFromResponse } from '../../types';
import { BACKEND_ACCOUNT_PROVIDER_USER } from '../../backend-paths';


export const accountProviderUserReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_ACCOUNT_PROVIDER_USER}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ACCOUNT_PROVIDER_USER}/${payload}`;

		return HttpService.get<TAccountProviderUserResponse>(path).then(result => {
			return adaptAccountProviderUserFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TAccountProviderUser> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountProviderUserReadSlice = createSlice({
	name: 'accountProviderUserReadSlice',
	initialState,
	reducers: {
		setAccountProviderUserRead(state, action: PayloadAction<TAccountProviderUser>) {
			state.item = action.payload;
		},

		clearAccountProviderUserRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountProviderUserReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountProviderUserReadGetApi.fulfilled.type]: (state, action: PayloadAction<TAccountProviderUser>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountProviderUserReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountProviderUserReadSelector = () => useAppSelector(state => state[accountProviderUserReadSlice.name]);

export const { clearAccountProviderUserRead, setAccountProviderUserRead } = accountProviderUserReadSlice.actions;
